module.exports = __webpack_public_path__ + "img/customer-table-icon.8b658d37.svg";